/* eslint-disable */
var $ = window.jQuery = require('jquery');
import toast from '../../../services/toast';
import { mapGetters } from 'vuex';

export default {
  name: 'public-quiz-history',
  components: {},
  props: [],
  data() {
    return {
      quizData:{
        quizId:''
      },
      coursesId:'',
      quizQuesDetails:'',
      quiezzesHistory:'',
      pub_catID:'',
      nextStep: '',
      totalCount: '',
      loadmoreData: {},
      userLoading: false,
      quiezzesHistoryResults:[],
      attemptedHistoryId:'',
      refreshListLoading:false
    }
  },
  computed: {
    ...mapGetters([
      'getQuizDetailsByIdDataState',
      'getQuizzesHistoryDataState'
    ]),
    getQuizQuesDetails() {
      this.quizQuesDetails = this.$store.getters.getQuizDetailsByIdDataState
      return this.quizQuesDetails
    },
    getQuizzesHistory(){
      this.quiezzesHistory = this.$store.getters.getQuizzesHistoryDataState.data
      return this.quiezzesHistory
    },
    SetIntialStatus() {
      if (this.quiezzesHistory != undefined) {
        this.totalCount = this.quiezzesHistory.count
        this.nextStep = this.quiezzesHistory.next
        this.quiezzesHistoryResults = this.quiezzesHistory.results
      }
    }
  },
  mounted() {
    this.pub_catID = this.$route.params.quiz_catId,
    this.getQuizzesHistory
    this.getQuizQuesDetails
    this.SetIntialStatus
    this.quizData.quizId = this.$route.params.quizId;
  },
  methods: {
    refreshHistoriesLists(){
      this.refreshListLoading = true
      this.$store.dispatch('getQuizzesAllHistory', {
        id: this.quizData.quizId
        }).then((res)=>{
          this.quiezzesHistory = res.data.data
          this.refreshListLoading = false
        }).catch((err)=>{
          this.refreshListLoading = false
        })
    },
    getQuizzesHistoryAgainFun(){
      this.$store.dispatch('getQuizzesAllHistory', {
        id: this.quizData.quizId
        }).then((res)=>{
          this.quiezzesHistory = res.data.data
        }).catch((err)=>{})
    },
    loadmoreUser(url) {
      this.userLoading = true
      axios.get(url)
        .then((response) => {
          this.loadmoreData = response.data
          this.nextStep = this.loadmoreData.data.next
          this.$set(this.quiezzesHistory, 'next', this.nextStep)
          if (this.loadmoreData != undefined) {
            for (var i = 0; i < this.loadmoreData.data.results.length; i++) {
              this.quiezzesHistoryResults.push(this.loadmoreData.data.results[i]);
              this.userLoading = false
            }
          }
        });
    },
    updateAttemptedHistoryFun(id){
      this.attemptedHistoryId = id
      this.submitted = true
      let data = {
        is_deleted : true
      }
      this.$store.dispatch('updateUserAttemptedHistoryFun',{data:{data:data, id:this.attemptedHistoryId}}).then((res) => {
        toast.success(res.data.msg);
        this.getQuizzesHistoryAgainFun()
        this.attemptedHistoryId = ''
      }).catch((err) => {

      })
    },
    updateFalseAttemptedHistoryFun(id){
      this.attemptedHistoryId = id
      this.submitted = true
      let data = {
        is_deleted : false
      }
      this.$store.dispatch('updateUserAttemptedHistoryFun',{data:{data:data, id:this.attemptedHistoryId}}).then((res) => {
        toast.success(res.data.msg);
        this.getQuizzesHistoryAgainFun()
        this.attemptedHistoryId = ''
      }).catch((err) => {

      })
    }
  },
  beforeMount() {
  },
  watch: {
    getQuizQuesDetails() {
      return this.$store.getters.getQuizDetailsByIdDataState
    },
    getQuizzesHistory(){
      return this.$store.getters.getQuizzesHistoryDataState
    },
    SetIntialStatus() {
      if (this.quiezzesHistory != undefined) {
        this.totalCount = this.quiezzesHistory.count
        this.nextStep = this.quiezzesHistory.next
        this.quiezzesHistoryResults = this.quiezzesHistory.results
      }
    }
  },
}